"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const PanelSection_1 = __importDefault(require("../shared/PanelSection"));
const folder_1 = require("../../../server/models/folder");
const HomePageFolderList_1 = __importDefault(require("./HomePageFolderList"));
const ReportViewToggle_1 = __importStar(require("../shared/ReportViewToggle"));
const recoil_1 = require("recoil");
const NavBar_1 = __importDefault(require("../NavBar"));
const react_router_dom_1 = require("react-router-dom");
const FoldersHomePage = ({ t, tReady }) => {
    const [folders, setFolders] = (0, react_1.useState)();
    const isMounted = (0, react_1.useRef)(true);
    const setCount = (0, recoil_1.useSetRecoilState)(ReportViewToggle_1.recordCountTableState);
    const setType = (0, recoil_1.useSetRecoilState)(ReportViewToggle_1.recordTypeSwitcherState);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [errorState, setErrorState] = (0, react_1.useState)({ hasError: false, redirectUrl: '' });
    const handleResponseErrors = (err) => {
        if (err.response.status === 404) {
            setErrorState({ hasError: true, redirectUrl: '/notfound' });
        }
        else {
            setErrorState({ hasError: true, redirectUrl: '/error' });
        }
    };
    const updateFoldersWithResponse = (folders) => {
        if (isMounted.current) {
            setFolders(folders);
            setType('all');
            setIsLoading(false);
            setCount(folders?.length || 0);
        }
    };
    const getFolders = (0, react_1.useCallback)(() => {
        isMounted.current = true;
        setCount(0);
        (0, folder_1.getHomePageFolders)()
            .then(updateFoldersWithResponse)
            .catch((err) => {
            handleResponseErrors(err);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        getFolders();
        return () => {
            isMounted.current = false;
        };
    }, [getFolders]);
    if (errorState.hasError) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: errorState.redirectUrl });
    }
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
        react_1.default.createElement(NavBar_1.default, null,
            react_1.default.createElement(PanelSection_1.default, { routes: [{ displayName: t('folderHeader'), path: '' }], subTitle: t('folderSubtitle') },
                react_1.default.createElement(ReportViewToggle_1.default, { showDropdown: false }),
                react_1.default.createElement("br", null),
                react_1.default.createElement(HomePageFolderList_1.default, { showTitle: false, folders: folders ?? [], isLoading: isLoading })))));
};
exports.default = (0, react_i18next_1.withTranslation)()(FoldersHomePage);
